import { AxiosInstance } from "axios";

interface updatePayload {
  pickup_loop_counter: number;
  pickup_count: number;
}
export class BroadcastingUpdateRequest {
  private protectedAxiosInstance: AxiosInstance;

  constructor(protectedAxiosInstance: AxiosInstance) {
    this.protectedAxiosInstance = protectedAxiosInstance;
  }

  private getPath(broadcastId) {
    return `/admin/voice-broadcasts/${broadcastId}/update`;
  }

  async update(broadcastId: number, payload: updatePayload) {
    try {
      const { data } = await this.protectedAxiosInstance.post(
        this.getPath(broadcastId),
        payload
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
}
